import { render, staticRenderFns } from "./PaymentOrderPage.vue?vue&type=template&id=21279181&lang=pug&"
import script from "./PaymentOrderPage.vue?vue&type=script&lang=js&"
export * from "./PaymentOrderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports